import React, { useEffect, useRef, useState } from "react";
import Swal from 'sweetalert2';

import { estructuraTarea } from "../../utils/estructuras";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faThumbsDown, faThumbsUp } from "@fortawesome/free-solid-svg-icons";

import './ImagenInteractivaPreviewCK.css';
import SelectCtrlMenu from "./SelectCtrlMenu";

const ImagenInteractivaPreviewCK = ({imageSrc, setImageSrc, file, setFile, imageSrc2, setImageSrc2, file2, setFile2, optionsCtrls, handleChange, controles}) => {

    const [clicks,setClicks] = useState([]); //[{x: 4, y: 5}, {x: 4, y: -7}];
    const [showSelectCtrl, setShowSelectCtrl] = useState(false);
    const [posSelectCtrl, setPosSelectCtrl] = useState({x:null, y:null});
    const [editingClick, setEditingClick] = useState(null);

    const menuRef = useRef(null);
    const firstFileRef = useRef(null);
    const secondFileRef = useRef(null);

    const handleImageUpdload = e => {
        const fileToUpload = e.target.files[0];
        if(!fileToUpload) return;
        setFile(fileToUpload);
        const reader = new FileReader();
        reader.onload = () => setImageSrc(reader.result);
        reader.readAsDataURL(fileToUpload);
    }
    
    const handleImage2Updload = e => {
        const fileToUpload = e.target.files[0];
        if(!fileToUpload) return;
        setFile2(fileToUpload);
        const reader = new FileReader();
        reader.onload = () => setImageSrc2(reader.result);
        reader.readAsDataURL(fileToUpload);
    }

    const handleClickOnImage = (e, imgNro) => {
        const rect = e.currentTarget.getBoundingClientRect();
        const x = ((e.clientX - rect.left) / rect.width) * 100;
        const y = ((e.clientY - rect.top) / rect.height) * 100;
        setClicks(prev => [...prev, {x, y}]);
        setEditingClick({x, y, imgNro});
        setPosSelectCtrl({x: e.clientX, y: e.clientY});
        setShowSelectCtrl(true);
    }

    const handleClickClicked = (e, c) => {
        e.preventDefault();
        e.stopPropagation();
        setEditingClick(c);
        setPosSelectCtrl({x: e.clientX, y: e.clientY});
        setShowSelectCtrl(true);
    }

    const handleDeleteControlFromSelectMenu = () => {
        if(editingClick.controlSelected){
            let newCtrls = [...controles].filter(pC => pC.x != editingClick.x);
            handleChange(undefined, 'controles', newCtrls);
        }else{
            setClicks(prev => [...prev.filter(cP => cP.x != editingClick.x)]);
        }
        setShowSelectCtrl(false);
        setPosSelectCtrl({x: null, y: null});
    }

    const ctrlSelected = c => {
        let newCtrls = [...controles].filter(cP => cP.x != editingClick.x);
        newCtrls[newCtrls.length - 1] = {...c, x: editingClick.x, y: editingClick.y, imgNro: editingClick.imgNro};
        newCtrls.push({...estructuraTarea});
        setClicks(prev => [...prev.filter(cP => cP.x != editingClick.x)]);
        handleChange(undefined, 'controles', newCtrls);
        setShowSelectCtrl(false);
        setPosSelectCtrl({x: null, y: null});
        setEditingClick(null);
    }

    const handleCloseSelectCtrlMenu = e => {
        e.preventDefault();
        e.stopPropagation();
        if(clicks.some(c => c.x == editingClick.x)){
            setClicks(prevClicks => [...prevClicks.filter(pC => pC.x != editingClick.x)]);
        }
        setShowSelectCtrl(false);
        setPosSelectCtrl({x: null, y: null});
    }

    const handleWorkNewImg = (e, imgNro) => {
        e.preventDefault();
        Swal.fire({
            title:'Esta seguro?',
            text:'Si continua debera cargar una nueva imagen y los controles asociados a la actual seran eliminados.',
            confirmButtonColor:'red',
            showConfirmButton:true,
            cancelButtonColor:'blue',
            showCancelButton:true
        }).then((res) => {
            if(res.isConfirmed){
                let newCtrls = controles.map(c => ({...c, x: c.imgNro == imgNro ? null : c.x, y: c.imgNro == imgNro ? null : c.y}));
                if(imgNro == 1) {
                    setImageSrc(null);
                    setFile('delete'); //Si se reinicia, se setea que file existente debera borrarse.
                }else{
                    setImageSrc2(null);
                    setFile2('delete'); //Si se reinicia, se setea que file existente debera borrarse.
                }
                handleChange(undefined, 'controles', newCtrls);
            }
        })
    }

    return <div style={{display:'flex', width:'100%'}}>
        <div className="interactiveImageCKContainer">
            {
                imageSrc ? <button className="handleImgFilesCK" onClick={(e)=>handleWorkNewImg(e, 1)}>Trabajar sobre nueva imagen</button> : <div style={{display:'flex', flexDirection:'column', alignItems:'center', gap:8}}>
                    <label className="handleImgFilesCK" onClick={()=>firstFileRef.current?.click()}>Trabajar sobre imagen</label>
                    <input style={{opacity:0}} ref={firstFileRef} type="file" accept="image/*" onChange={handleImageUpdload}/>
                </div>
            }
            {
                imageSrc && <div style={{position:'relative', display:'inline-block', marginTop:20}} onClick={(e)=>handleClickOnImage(e, 1)}>
                    <img src={imageSrc} alt="preview" style={{ height: 'auto', cursor: 'crosshair', maxWidth: '700px', maxHeight: '500px'}}/>
                    {
                        clicks.filter(c => c.imgNro == 1).map((c, i) => <div key={i} className="clickOnImageDiv" 
                            style={{ 
                                position:'absolute', 
                                zIndex:999,
                                padding: 10,
                                top: `${c.y}%`, left: `${c.x}%`,
                                transform: 'translate(-50%, -50%)',
                                display:"flex",
                                gap:4
                            }}
                            onClick={(e) => handleClickClicked(e, c)}
                            onContextMenu={e => e.preventDefault()}
                            >
                                <FontAwesomeIcon className="thumbImgCtrls" style={{color:'grey'}} icon={faThumbsDown}/>
                                <FontAwesomeIcon className="thumbImgCtrls" style={{color:'grey'}} icon={faThumbsUp}/>
                        </div>)
                    }
                    {   
                        controles.filter(c => c.x && c.y && c.imgNro == 1).map((c, i) => <div key={i} className="clickOnImageDiv" 
                            style={{ 
                                position:'absolute', 
                                zIndex:999,
                                padding: 10,
                                top: `${c.y}%`, left: `${c.x}%`,
                                transform: 'translate(-50%, -50%)',
                                display: 'flex',
                                gap: 4
                            }}
                            title={c.label}
                            onClick={(e) => handleClickClicked(e, {...c, controlSelected: true})}
                            onContextMenu={e => e.preventDefault()}
                            >
                                <FontAwesomeIcon className="thumbImgCtrls" style={{color:'red'}} icon={faThumbsDown}/>
                                <FontAwesomeIcon className="thumbImgCtrls" style={{color:'green'}} icon={faThumbsUp}/>
                        </div>)
                    }
                </div>
            }
        </div>
        {
            (imageSrc && !imageSrc2) && <div className="interactiveImageCKContainer">
                <button className="handleImgFilesCK" onClick={e => {e.preventDefault(); secondFileRef?.current.click();}}>Agregar segunda imagen</button>
                <input ref={secondFileRef} style={{opacity:0}} type="file" accept="image/*" onChange={handleImage2Updload}/>
            </div> 
        }
        {
            imageSrc2 ? <div className="interactiveImageCKContainer">
                {
                    imageSrc2 ? <button className="handleImgFilesCK" onClick={(e)=>handleWorkNewImg(e, 2)}>Trabajar sobre nueva imagen</button> : <input type="file" accept="image/*" onChange={handleImage2Updload}/>
                }
                {
                    imageSrc2 && <div style={{position:'relative', display:'inline-block', marginTop:20}} onClick={(e)=>handleClickOnImage(e, 2)}>
                        <img src={imageSrc2} alt="preview" style={{ height: 'auto', cursor: 'crosshair', maxWidth: '700px', maxHeight: '500px'}}/>
                        {
                            clicks.filter(c => c.imgNro == 2).map((c, i) => <div key={i} className="clickOnImageDiv" 
                                style={{ 
                                    position:'absolute', 
                                    zIndex:999,
                                    padding: 10,
                                    top: `${c.y}%`, left: `${c.x}%`,
                                    transform: 'translate(-50%, -50%)',
                                    display:"flex",
                                    gap:4
                                }}
                                onClick={(e) => handleClickClicked(e, c)}
                                onContextMenu={e => e.preventDefault()}
                                >
                                    <FontAwesomeIcon className="thumbImgCtrls" style={{color:'grey'}} icon={faThumbsDown}/>
                                    <FontAwesomeIcon className="thumbImgCtrls" style={{color:'grey'}} icon={faThumbsUp}/>
                            </div>)
                        }
                        {   
                            controles.filter(c => c.x && c.y && c.imgNro == 2).map((c, i) => <div key={i} className="clickOnImageDiv" 
                                style={{ 
                                    position:'absolute', 
                                    zIndex:999,
                                    padding: 10,
                                    top: `${c.y}%`, left: `${c.x}%`,
                                    transform: 'translate(-50%, -50%)',
                                    display: 'flex',
                                    gap: 4
                                }}
                                title={c.label}
                                onClick={(e) => handleClickClicked(e, {...c, controlSelected: true})}
                                onContextMenu={e => e.preventDefault()}
                                >
                                    <FontAwesomeIcon className="thumbImgCtrls" style={{color:'red'}} icon={faThumbsDown}/>
                                    <FontAwesomeIcon className="thumbImgCtrls" style={{color:'green'}} icon={faThumbsUp}/>
                            </div>)
                        }
                    </div>
                }
            </div> : null
        }

        {
            ((imageSrc || imageSrc2) && showSelectCtrl) && <SelectCtrlMenu ref={menuRef} showSelectCtrl={posSelectCtrl} handleCloseSelectCtrlMenu={handleCloseSelectCtrlMenu} handleDeleteControlFromSelectMenu={handleDeleteControlFromSelectMenu} optionsCtrls={optionsCtrls} controles={controles} editingClick={editingClick} ctrlSelected={ctrlSelected} />
        }
    </div>

}

export default ImagenInteractivaPreviewCK;